import Validate from "../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {
  name: undefined, // required - Tên nhóm
  description: undefined, // optional - Mô tả nhóm
  icon_id: undefined, // optional, ref: mushroom_file - File icon
  menu: undefined, // optional - Hiển thị trên menu (giới hạn MaxGroupCount bản ghi có menu=true)
  auto: undefined, // optional - Tự động tạo từ hệ thống
  list_service: [], // optional - Danh sách service health thuộc nhóm
  // optional - Thông tin link
  link_info: {
    target_domain: undefined, // optional, enum(primary, probe, bras) - Phân hệ
    target_type: undefined, // optional, enum(static, service, table_screen, usecase, dynamic) - Phân loại trang đích
    target_id: undefined, // optional, ref: service|table_screen|usecase|dynamic_dashboard - Không bắt buộc với target_type=static, còn lại là bắt buộc
    link_parameters: [
      // optional - Danh sách các tham số
      {
        code: undefined, // optional, pattern: /^\w+$/, minLength: 1 - Mã tham số
        value: undefined, // optional - Giá trị tham số
      },
    ],
    link: undefined, // optional - Đường dẫn menu
  },
  default_chart_type: undefined, // optional, enum(line, bar) - Loại chart mặc định
  // optional - Các thuộc tính của line-chart
  line_chart: {
    tooltip: undefined, // optional - Tooltip
    sql: undefined, // optional - câu truy vấn để lấy dữ liệu
    sql_table_formats: [], // optional - câu truy vấn con trong biến @table dạng select..from @table_name where...
    table_config_id: undefined, // optional, ref: table_config - Mã của table_config
    service_id: undefined, // optional, ref: service - Id của service
  },
  // optional - Các thuộc tính của bar-chart
  bar_chart: {
    tooltip: undefined, // optional - Tooltip
    sql: undefined, // optional - câu truy vấn để lấy dữ liệu
    sql_table_formats: [], // optional - câu truy vấn con trong biến @table dạng select..from @table_name where...
    table_config_id: undefined, // optional, ref: table_config - Mã của table_config
    service_id: undefined, // optional, ref: service - Id của service
  },
  // optional - Các thuộc tính của table
  table: {
    tooltip: undefined, // optional - Tooltip
    sql: undefined, // optional - câu truy vấn để lấy dữ liệu
    sql_table_formats: [], // optional - câu truy vấn con trong biến @table dạng select..from @table_name where...
    table_config_id: undefined, // optional, ref: table_config - Mã của table_config
    service_id: undefined, // optional, ref: service - Id của service
  },
};

model.validForm = {
  name: [Validate.required],
};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  fields: "id,menu,auto,name,description,icon_id,list_service",
  filters: "",
  dataSearch: {
    value: {
      name: "",
    },
    operator: {
      name: ":regex_i:",
    },
  },
};

export default model;
